import React from 'react'

import { classNames } from '../../util/class-names'

interface CardHeaderProps {
  className?: string
}

export const CardHeader: React.FC<CardHeaderProps> = ({ className, ...props }) => {
  return <div className={classNames('card-header', className)} {...props} />
}
